import React from "react";
import { Tabel, DropDown, DropDownMenu } from "../core";
import { Link } from "react-router-dom";
import { Menu } from "antd";
const CHANGE_DATE_FORMAT = require("../helper/utils/datFormat");
const invoice = [
  {
    title: "SR #",
    dataIndex: "SNo",
    key: "S.No",
    width: 150,
  },
  {
    title: "Tar/BackBeam",
    dataIndex: "tarbackbeam",
    key: "tarbackbeam",
    width: 150,
  },
  {
    title: "Date",
    dataIndex: "date",
    key: "date",
    render: (text, record, index) => {
      return <span>{CHANGE_DATE_FORMAT.changeDateFormat(record.date)}</span>;
    },
    width: 150,
  },
  {
    title: "Payment/Rs",
    dataIndex: "payment",
    key: "payment",
    width: 150,
  },
  {
    title: "",
    dataIndex: "action",
    width: 150,
    render: (text, record, index) => (
      <DropDown
        overlay={<MenuCompo index={index} record={record} />}
        record={record}
      />
    ),
  },
];
const invoiceData = [];
for (let i = 0; i < 46; i++) {
  invoiceData.push({
    SNo: i + 1,
    key: i + 1,
    tarbackbeam: "650/50",
    date: "Des-22-2019",
    payment: "650",
  });
}

const PaymentHistory = ({ pagination, PaymentHistoryData, ...props }) => {
  return (
    <Tabel
      padding="0px"
      pagination={pagination}
      columns={invoice}
      data={PaymentHistoryData}
    />
  );
};
const MenuCompo = (props) => {
  const { contarctNumber } = props.record;
  return (
    <div>
      <DropDownMenu>
        <Menu.Item className="menu--item" key="delete">
          <Link to={`/contract-inner/${contarctNumber}`}>Delete</Link>
        </Menu.Item>
        <Menu.Item className="menu--item" key="edit">
          <Link to={`/contract-inner/${contarctNumber}`}>Edit</Link>
        </Menu.Item>
      </DropDownMenu>
    </div>
  );
};
export default PaymentHistory;
